import PageName from '@/utils/define/PageName'

// 모바일 폭에서 PC 화면 대신 보여줄 화면. (경로와 이름은 PC와 같고 컴포넌트만 바꿔 끼운다)
// 여기에 없는 화면은 모바일에서도 PC 화면이 그대로 나온다.
export default {
	[PageName.Main]: () => import('@/views/mobile/Main.vue'),
}
